var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/polls/poll.tsx";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/web.dom-collections.iterator.js";
import React, { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { openModal } from 'soapbox/actions/modals';
import { vote } from 'soapbox/actions/polls';
import { useAppDispatch, useAppSelector } from 'soapbox/hooks';
import { Stack, Text } from '../ui';
import PollFooter from './poll-footer';
import PollOption from './poll-option';
const messages = defineMessages({
  multiple: {
    "id": "poll.choose_multiple",
    "defaultMessage": "Choose as many as you'd like."
  }
});

const Poll = _ref => {
  let {
    id,
    status
  } = _ref;
  const dispatch = useAppDispatch();
  const intl = useIntl();
  const isLoggedIn = useAppSelector(state => state.me);
  const poll = useAppSelector(state => state.polls.get(id));
  const [selected, setSelected] = useState({});

  const openUnauthorizedModal = () => dispatch(openModal('UNAUTHORIZED', {
    action: 'POLL_VOTE',
    ap_id: status
  }));

  const handleVote = selectedId => dispatch(vote(id, [String(selectedId)]));

  const toggleOption = value => {
    if (isLoggedIn) {
      if (poll !== null && poll !== void 0 && poll.multiple) {
        const tmp = _objectSpread({}, selected);

        if (tmp[value]) {
          delete tmp[value];
        } else {
          tmp[value] = true;
        }

        setSelected(tmp);
      } else {
        const tmp = {};
        tmp[value] = true;
        setSelected(tmp);
        handleVote(value);
      }
    } else {
      openUnauthorizedModal();
    }
  };

  if (!poll) return null;
  const showResults = poll.voted || poll.expired;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    React.createElement("div", {
      onClick: e => e.stopPropagation(),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 68,
        columnNumber: 5
      }
    }, !showResults && poll.multiple && /*#__PURE__*/React.createElement(Text, {
      theme: "muted",
      size: "sm",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 70,
        columnNumber: 9
      }
    }, intl.formatMessage(messages.multiple)), /*#__PURE__*/React.createElement(Stack, {
      space: 4,
      className: "mt-4",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 75,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(Stack, {
      space: 2,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 76,
        columnNumber: 9
      }
    }, poll.options.map((option, i) => /*#__PURE__*/React.createElement(PollOption, {
      key: i,
      poll: poll,
      option: option,
      index: i,
      showResults: showResults,
      active: !!selected[i],
      onToggle: toggleOption,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 78,
        columnNumber: 13
      }
    }))), /*#__PURE__*/React.createElement(PollFooter, {
      poll: poll,
      showResults: showResults,
      selected: selected,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 90,
        columnNumber: 9
      }
    })))
  );
};

export default Poll;